// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_hb-0";